import { useModal } from '@billy/design-system'
import { createContext, ReactElement, ReactNode, useCallback, useContext } from 'react'

interface OpenBankingAutoConnectContextValue {
  handleCloseModal: () => void
  targetAccountIds: string[]
}

const OpenBankingAutoConnectContext = createContext<OpenBankingAutoConnectContextValue | undefined>(undefined)

interface OpenBankingAutoConnectContextProviderProps {
  children: ReactNode
  modalId: string
  removeQueryParams: () => void
  targetAccountIds: string[]
}

export const OpenBankingAutoConnectContextProvider = ({
  children,
  modalId,
  removeQueryParams,
  targetAccountIds,
}: OpenBankingAutoConnectContextProviderProps): ReactElement => {
  const { close } = useModal(modalId)

  const handleCloseModal = useCallback(() => {
    removeQueryParams()
    close()
  }, [close, removeQueryParams])

  return (
    <OpenBankingAutoConnectContext.Provider value={{ handleCloseModal, targetAccountIds }}>
      {children}
    </OpenBankingAutoConnectContext.Provider>
  )
}

export const useOpenBankingAutoConnectModal = (): OpenBankingAutoConnectContextValue => {
  const context = useContext(OpenBankingAutoConnectContext)

  if (!context) {
    throw new Error('useOpenBankingAutoConnectModal must be used within OpenBankingAutoConnectContextProvider')
  }

  return context
}
